export default __webpack_public_path__ + "static/media/az2.f9d757db.jpeg";